import styled from 'styled-components';
var theme = {
  Main: styled.div.withConfig({
    displayName: "theme__Main",
    componentId: "sc-1fcruer-0"
  })([""]),
  Head: styled.div.withConfig({
    displayName: "theme__Head",
    componentId: "sc-1fcruer-1"
  })(["position:relative;display:block;width:100%;background:none;border:none;text-align:left;transition:color 0.2s linear;cursor:pointer;&:focus{outline:none;}"]),
  Body: styled.div.withConfig({
    displayName: "theme__Body",
    componentId: "sc-1fcruer-2"
  })(["overflow:hidden;will-change:height;transition:height 0.4s cubic-bezier(.65,.05,.36,1);height:", ";"], function (pr) {
    return pr.heightProp;
  }),
  Content: styled.div.withConfig({
    displayName: "theme__Content",
    componentId: "sc-1fcruer-3"
  })(["opacity:", ";transition:opacity 0.3s linear 0.18s;"], function (pr) {
    return pr.visible ? 1 : 0;
  })
};
export default theme;